<div class="editor">
  <div style="display: flex; align-items: center; gap: 4px; flex-wrap: wrap;">
    <button [ngClass]="configMode == 'basic' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'basic'">
      <span>{{('cau_hinh_co_ban') | translate}}</span>
    </button>
  
    <button [ngClass]="configMode == 'advanced' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'advanced'">
      <span>{{('cau_hinh_nang_cao') | translate}}</span>
    </button>
  </div>
  <!-- Cấu hình cơ bản -->
  <ng-container *ngIf="configMode == 'basic'">
    <div style="margin-top: 10px">
        <!-- Hiển thị đơn vị tiền tệ -->
        <div class="text-hidden">
        <span style="line-height: 1.5;">{{'hien_thi_don_vi_tien_te' | translate}}</span>
        <nz-switch [(ngModel)]="config['currency']['currency_check']"
          (ngModelChange)="updateConfig()"></nz-switch>
      </div>
      <div class="field-row">
        <div class="config-font-size">
          <!-- Font Family -->
          <div class="field-row-font" style="width:65%">
            <mat-form-field style="width:100%">
              <mat-label>Font</mat-label>
              <mat-select [(ngModel)]="class['fee__wrapper']['font-family']" (ngModelChange)="updateClass();">
                <mat-option *ngFor="let font of fonts" [value]="font.value">{{font.name}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <!-- Font size -->
          <div class="field-row-size" style="width:35%;padding-right:5px">
            <mat-form-field style="width:100%">
              <mat-label>{{'kich_thuoc' | translate}}</mat-label>
              <input matInput type="number" [min]="1" [max]="200"
                [ngModel]="class['fee__content']['font-size'] | vhnumber"
                (ngModelChange)="class['fee__content']['font-size'] = $event +'px'" (blur)="updateClass()">
            </mat-form-field>
          </div>
        </div>
      </div>
      <!-- Kiểu chữ (Đậm/Nghiêm/Gạch chân/In hoa/Màu chữ) -->
      <div class="field-row">
        <div class="config-font">
          <p class="title">{{'kieu_chu' | translate}}</p>
          <div class="font">
            <!-- In đậm -->
            <button class="font-text-btn font-text-btn-bold" title="bold" nz-button [nzType]="
              class['fee__content']['font-weight'] == 'bold'
                ? 'primary'
                : 'default'
              " (click)="
                class['fee__content']['font-weight'] =
                  class['fee__content']['font-weight'] == 'bold'
                    ? '400'
                    : 'bold'
              " (click)="updateClass();">
              <span style="font-weight: 500;">B</span>
            </button>
            <!-- In nghiêng -->
            <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button [nzType]="
              class['fee__content']['font-style'] == 'italic'
                ? 'primary'
                : 'default'
              " (click)="
                class['fee__content']['font-style'] =
                  class['fee__content']['font-style'] == 'normal'
                    ? 'italic'
                    : 'normal'
              " (click)="updateClass();">
              <i nz-icon nzType="italic" nzTheme="outline" style="font-size: 14px"></i>
            </button>
            <!-- Gạch dưới -->
            <button class="font-text-btn font-text-btn-underline" title="Underline" nz-button [nzType]="
              class['fee__wrapper']['text-decoration'] == 'underline'
                ? 'primary'
                : 'default'
              " (click)="
                class['fee__wrapper']['text-decoration'] =
                  class['fee__wrapper']['text-decoration'] == 'none'
                    ? 'underline'
                    : 'none'
              " (click)="updateClass();">
              <i nz-icon nzType="underline" nzTheme="outline" style="font-size: 14px"></i>
            </button>
            <!-- Màu chữ -->
            <input class="input-color"
              style="width:17%;flex:none;border-radius:5px;border:0;box-shadow:1px 1px 2px #aaa"
              [style.background]="class['fee__wrapper']['color']" [cpOKButton]="true"
              [(colorPicker)]="class['fee__wrapper']['color']" (colorPickerClose)="updateClass()" type="button" />
          </div>
        </div>
      </div>
      <!-- Canh lề -->
      <div class="field-row">
        <div class="config-font">
          <p class="title">{{'canh_le' | translate}}</p>
          <div class="font">
            <button class="font-text-btn" nz-button [nzType]="
                class['fee__wrapper']['justify-content'] == 'flex-start'
                  ? 'primary'
                  : 'default'
              " (click)="
                class['fee__wrapper']['justify-content'] = 'flex-start';
                class['fee__content']['text-align'] = 'left';
              " (click)="updateClass();">
              <i nz-icon nzType="align-left" nzTheme="outline"></i>
            </button>
            <button class="font-text-btn" nz-button [nzType]="
                class['fee__wrapper']['justify-content'] == 'center'
                  ? 'primary'
                  : 'default'
              " (click)="
                class['fee__wrapper']['justify-content'] = 'center';
                class['fee__content']['text-align'] = 'center';
              " (click)="updateClass();">
              <i nz-icon nzType="align-center" nzTheme="outline"></i>
            </button>
            <button class="font-text-btn" nz-button [nzType]="
                class['fee__wrapper']['justify-content'] == 'flex-end'
                  ? 'primary'
                  : 'default'
              " (click)="
                class['fee__wrapper']['justify-content'] = 'flex-end';
                class['fee__content']['text-align'] = 'right';
              " (click)="updateClass();">
              <i nz-icon nzType="align-right" nzTheme="outline"></i>
            </button>
            <button class="font-text-btn" nz-button [nzType]="
                class['fee__content']['text-align'] == 'justify'
                  ? 'primary'
                  : 'default'
              " (click)="
                class['fee__wrapper']['justify-content'] = '';
                class['fee__content']['text-align'] = 'justify';
              " (click)="updateClass();">
              <i class="bi bi-justify"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="field-row">
        <div class="config-font" style="margin-top:20px">
          <!-- Khoảng cách chữ -->
          <div class="font-text-letterspacing">
            <div class="config-name" style="gap:5px">
              <p class="m-0" style="line-height:1.5">{{ 'khoang_cach_chu' | translate }}</p>
              <nz-input-number [nzMin]="0" [nzMax]="50" [ngStyle]="{ width: '40%' }"
                [ngModel]="class['fee__content']['letter-spacing'] | vhnumber" (nzBlur)="updateClass()"
                (ngModelChange)="class['fee__content']['letter-spacing'] = $event +'px'">
              </nz-input-number>
            </div>
            <nz-row>
              <nz-col nzSpan="24">
                <nz-slider [nzMin]="0" [nzMax]="50" [ngModel]="class['fee__content']['letter-spacing'] | vhnumber"
                  (nzOnAfterChange)="updateClass();"
                  (ngModelChange)="class['fee__content']['letter-spacing'] = $event +'px'">
                </nz-slider>
              </nz-col>
            </nz-row>
          </div>
          <!-- Khoảng cách dòng -->
          <div class="font-text-linespacing">
            <div class="config-name">
              <p class="m-0" style="line-height:1.5">{{ 'khoang_cach_dong' | translate }}</p>
              <nz-input-number [ngStyle]="{ width: '40%' }"
                [(ngModel)]="this.class['fee__content']['line-height']" (nzBlur)="updateClass()" [nzMin]="0.5"
                [nzMax]="3" [nzStep]="0.1">
              </nz-input-number>
            </div>
            <nz-row>
              <nz-col nzSpan="24">
                <nz-slider [nzMin]="0.5" [nzMax]="3" [nzStep]="0.1"
                  [(ngModel)]="this.class['fee__content']['line-height']" (nzOnAfterChange)="updateClass()">
                </nz-slider>
              </nz-col>
            </nz-row>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }}</span>
  </div>
  <ng-container *ngIf="!isViewAll && configMode == 'advanced'">
    <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
      <!-- CHỮ VÀ ĐỊNH DẠNG-->
      <li nz-submenu nzTitle="{{'hien_thi' | translate}}" [(nzOpen)]="openMap.menu0" (nzOpenChange)="openHandler('menu0')">
        <!-- Lựa chọn hiển thị cho các thiết bị -->
        <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
        </app-hide-show-config>
      </li>
      <!-- CHỮ VÀ ĐỊNH DẠNG-->
      <li nz-submenu nzTitle="{{'chu_va_dinh_dang' | translate}}" [(nzOpen)]="openMap.menu1" (nzOpenChange)="openHandler('menu1')">
        <div class="editor-field">
          <div class="editor-field-body">
            <!-- Hiển thị đơn vị tiền tệ -->
            <div class="text-hidden">
              <span style="line-height: 1.5;">{{'hien_thi_don_vi_tien_te' | translate}}</span>
              <nz-switch [(ngModel)]="config['currency']['currency_check']"
                (ngModelChange)="updateConfig()"></nz-switch>
            </div>
            <div class="field-row">
              <div class="config-font-size">
                <!-- Font Family -->
                <div class="field-row-font" style="width:65%">
                  <mat-form-field style="width:100%">
                    <mat-label>Font</mat-label>
                    <mat-select
                      [(ngModel)]="class['fee__wrapper']['font-family']"
                      (ngModelChange)="updateClass();">
                      <mat-option *ngFor="let font of fonts" [value]="font.value">{{font.name}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <!-- Font size -->
                <div class="field-row-size" style="width:35%;padding-right:5px">
                  <mat-form-field style="width:100%">
                    <mat-label>{{'kich_thuoc' | translate}}</mat-label>
                    <input matInput type="number" [min]="1" [max]="200"
                      [ngModel]="class['fee__content']['font-size'] | vhnumber"
                      (ngModelChange)="class['fee__content']['font-size'] = $event +'px'"
                      (blur)="updateClass()">
                  </mat-form-field>
                </div>
              </div>
            </div>
            <!-- Kiểu chữ (Đậm/Nghiêm/Gạch chân/In hoa/Màu chữ) -->
            <div class="field-row">
              <div class="config-font">
                <p class="title">{{'kieu_chu' | translate}}</p>
                <div class="font">
                  <!-- In đậm -->
                  <button class="font-text-btn font-text-btn-bold" title="bold" nz-button [nzType]="
                    class['fee__content']['font-weight'] == 'bold'
                      ? 'primary'
                      : 'default'
                    "(click)="
                      class['fee__content']['font-weight'] =
                        class['fee__content']['font-weight'] == 'bold'
                          ? '400'
                          : 'bold'
                    "(click)="updateClass();">
                    <span style="font-weight: 500;">B</span>
                  </button>
                  <!-- In nghiêng -->
                  <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button [nzType]="
                    class['fee__content']['font-style'] == 'italic'
                      ? 'primary'
                      : 'default'
                    "(click)="
                      class['fee__content']['font-style'] =
                        class['fee__content']['font-style'] == 'normal'
                          ? 'italic'
                          : 'normal'
                    "(click)="updateClass();">
                    <i nz-icon nzType="italic" nzTheme="outline" style="font-size: 14px"></i>
                  </button>
                  <!-- Gạch dưới -->
                  <button class="font-text-btn font-text-btn-underline" title="Underline" nz-button [nzType]="
                    class['fee__wrapper']['text-decoration'] == 'underline'
                      ? 'primary'
                      : 'default'
                    "(click)="
                      class['fee__wrapper']['text-decoration'] =
                        class['fee__wrapper']['text-decoration'] == 'none'
                          ? 'underline'
                          : 'none'
                    "(click)="updateClass();">
                    <i nz-icon nzType="underline" nzTheme="outline" style="font-size: 14px"></i>
                  </button>
                  <!-- Màu chữ -->
                  <input class="input-color" style="width:17%;flex:none;border-radius:5px;border:0;box-shadow:1px 1px 2px #aaa"
                    [style.background]="class['fee__wrapper']['color']"
                    [cpOKButton]="true" [(colorPicker)]="class['fee__wrapper']['color']"
                    (colorPickerClose)="updateClass()"  type="button"/>
                </div>
              </div>
            </div>
            <!-- Canh lề -->
            <div class="field-row">
              <div class="config-font">
                <p class="title">{{'canh_le' | translate}}</p>
                <div class="font">
                  <button class="font-text-btn" nz-button
                    [nzType]="
                      class['fee__wrapper']['justify-content'] == 'flex-start'
                        ? 'primary'
                        : 'default'
                    "(click)="
                      class['fee__wrapper']['justify-content'] = 'flex-start';
                      class['fee__content']['text-align'] = 'left';
                    "(click)="updateClass();">
                    <i nz-icon nzType="align-left" nzTheme="outline"></i>
                  </button>
                  <button class="font-text-btn" nz-button
                    [nzType]="
                      class['fee__wrapper']['justify-content'] == 'center'
                        ? 'primary'
                        : 'default'
                    "(click)="
                      class['fee__wrapper']['justify-content'] = 'center';
                      class['fee__content']['text-align'] = 'center';
                    "(click)="updateClass();">
                    <i nz-icon nzType="align-center" nzTheme="outline"></i>
                  </button>
                  <button class="font-text-btn" nz-button
                    [nzType]="
                      class['fee__wrapper']['justify-content'] == 'flex-end'
                        ? 'primary'
                        : 'default'
                    "(click)="
                      class['fee__wrapper']['justify-content'] = 'flex-end';
                      class['fee__content']['text-align'] = 'right';
                    "(click)="updateClass();">
                    <i nz-icon nzType="align-right" nzTheme="outline"></i>
                  </button>
                  <button class="font-text-btn" nz-button
                    [nzType]="
                      class['fee__content']['text-align'] == 'justify'
                        ? 'primary'
                        : 'default'
                    "(click)="
                      class['fee__wrapper']['justify-content'] = '';
                      class['fee__content']['text-align'] = 'justify';
                    "(click)="updateClass();">
                    <i class="bi bi-justify"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="field-row">
              <div class="config-font" style="margin-top:20px">
                <!-- Khoảng cách chữ -->
                <div class="font-text-letterspacing">
                  <div class="config-name" style="gap:5px">
                    <p class="m-0" style="line-height:1.5">{{ 'khoang_cach_chu' | translate }}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="50" [ngStyle]="{ width: '40%' }"
                      [ngModel]="class['fee__content']['letter-spacing'] | vhnumber"
                      (nzBlur)="updateClass()"
                      (ngModelChange)="class['fee__content']['letter-spacing'] = $event +'px'">
                    </nz-input-number>
                  </div>
                  <nz-row>
                    <nz-col nzSpan="24">
                      <nz-slider [nzMin]="0" [nzMax]="50"
                        [ngModel]="class['fee__content']['letter-spacing'] | vhnumber"
                        (nzOnAfterChange)="updateClass();"
                        (ngModelChange)="class['fee__content']['letter-spacing'] = $event +'px'">
                      </nz-slider>
                    </nz-col>
                  </nz-row>
                </div>
                <!-- Khoảng cách dòng -->
                <div class="font-text-linespacing">
                  <div class="config-name">
                    <p class="m-0" style="line-height:1.5">{{ 'khoang_cach_dong' | translate }}</p>
                    <nz-input-number [ngStyle]="{ width: '40%' }"
                      [(ngModel)]="this.class['fee__content']['line-height']"
                      (nzBlur)="updateClass()"
                      [nzMin]="0.5" [nzMax]="3" [nzStep]="0.1">
                    </nz-input-number>
                  </div>
                  <nz-row>
                    <nz-col nzSpan="24">
                      <nz-slider [nzMin]="0.5" [nzMax]="3" [nzStep]="0.1"
                        [(ngModel)]="this.class['fee__content']['line-height']"
                        (nzOnAfterChange)="updateClass()">
                      </nz-slider>
                    </nz-col>
                  </nz-row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </li>
      <!-- PHONG CÁCH -->
      <li nz-submenu nzTitle="{{'phong_cach_va_kieu_co' | translate}}" [(nzOpen)]="openMap.menu2" (nzOpenChange)="openHandler('menu2')">
        <div class="editor-field">
          <div class="editor-field-body">
            <div class="field-row">
              <div class="text-effect">
                <div class="text-effect-shape">
                  <div class="text-effect-shape-item" (click)="dispatchStyles('')">
                    <div [ngClass]="!config['text_style'] ? 'active' : ''" class="image">
                      <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
                        <defs>
                          <style>
                            .cls-1 {
                              fill: #ffa64d;
                            }
                          </style>
                        </defs>
                        <title>Phong_cach_va_kieu_co</title>
                        <path class="cls-1"
                          d="M28.71,34.78H24.1l-1,3.06h-3L25,23.63h2.92l4.78,14.21h-3Zm-3.9-2.24H28l-1.57-5h-.06Z" />
                        <path class="cls-1"
                          d="M33.39,32.65a6.77,6.77,0,0,1,1.09-4,3.49,3.49,0,0,1,3-1.54,3,3,0,0,1,1.56.4,3.53,3.53,0,0,1,1.16,1.15l.22-1.35h2.45V37.8A3.93,3.93,0,0,1,41.57,41a5.66,5.66,0,0,1-3.76,1.13,7,7,0,0,1-1.7-.22,7.1,7.1,0,0,1-1.66-.6l.47-2.13a6.67,6.67,0,0,0,1.36.48,7.14,7.14,0,0,0,1.51.16,2.58,2.58,0,0,0,1.72-.49,1.92,1.92,0,0,0,.55-1.52v-1a3.18,3.18,0,0,1-1.1.91,3.26,3.26,0,0,1-1.46.31,3.58,3.58,0,0,1-3-1.43,6,6,0,0,1-1.09-3.77Zm2.85.2A4.34,4.34,0,0,0,36.71,35a1.61,1.61,0,0,0,1.52.79,2.32,2.32,0,0,0,1.1-.24,1.8,1.8,0,0,0,.73-.69V30.32a1.91,1.91,0,0,0-.73-.76,2.16,2.16,0,0,0-1.08-.26,1.61,1.61,0,0,0-1.53.93,5.26,5.26,0,0,0-.48,2.42Z" />
                      </svg>
                    </div>
                    <div class="text-effect-description">{{'binh_thuong' | translate}}</div>
                  </div>
                  <!-- Đổ bóng -->
                  <div class="text-effect-shape-item" (click)="dispatchStyles('Đổ bóng')">
                    <div [ngClass]="config['text_style'] == 'shadow' ? 'active' : ''"
                      class="image">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
                        <defs>
                          <style>
                            .cls-2 {
                              isolation: isolate;
                            }

                            .cls-3 {
                              opacity: 0.75;
                              mix-blend-mode: multiply;
                            }

                            .cls-4 {
                              fill: #5e5e5e;
                            }

                            .cls-5 {
                              fill: #ffa64d;
                            }
                          </style>
                        </defs>
                        <title>Phong_cach_va_kieu_co</title>
                        <g class="cls-2">
                          <g id="Layer_2" data-name="Layer 2">
                            <g class="cls-3">
                              <path class="cls-4"
                                d="M31.24,35.78H26.63l-.95,3.06h-3l4.79-14.21h2.92l4.78,14.21h-3Zm-3.9-2.24h3.21l-1.57-5h-.06Z" />
                              <path class="cls-4"
                                d="M35.92,33.65a6.77,6.77,0,0,1,1.09-4,3.49,3.49,0,0,1,3-1.54,3,3,0,0,1,1.56.4,3.53,3.53,0,0,1,1.16,1.15L43,28.28h2.45V38.8A3.91,3.91,0,0,1,44.09,42a5.62,5.62,0,0,1-3.75,1.13,6.9,6.9,0,0,1-1.7-.22,7.1,7.1,0,0,1-1.66-.6l.47-2.13a6.67,6.67,0,0,0,1.36.48,7.07,7.07,0,0,0,1.51.16A2.58,2.58,0,0,0,42,40.31a1.92,1.92,0,0,0,.55-1.52v-1a3.18,3.18,0,0,1-1.1.91,3.26,3.26,0,0,1-1.46.31,3.58,3.58,0,0,1-3-1.43,6,6,0,0,1-1.09-3.77Zm2.85.2A4.34,4.34,0,0,0,39.24,36a1.61,1.61,0,0,0,1.52.79,2.32,2.32,0,0,0,1.1-.24,1.8,1.8,0,0,0,.73-.69V31.32a1.91,1.91,0,0,0-.73-.76,2.17,2.17,0,0,0-1.09-.26,1.6,1.6,0,0,0-1.52.93,5.26,5.26,0,0,0-.48,2.42Z" />
                            </g>
                            <path class="cls-5"
                              d="M29.24,34.78H24.63l-.95,3.06h-3l4.79-14.21h2.92l4.78,14.21h-3Zm-3.9-2.24h3.21l-1.57-5h-.06Z" />
                            <path class="cls-5"
                              d="M33.92,32.65a6.77,6.77,0,0,1,1.09-4,3.49,3.49,0,0,1,3-1.54,3,3,0,0,1,1.56.4,3.53,3.53,0,0,1,1.16,1.15L41,27.28h2.45V37.8A3.91,3.91,0,0,1,42.09,41a5.62,5.62,0,0,1-3.75,1.13,6.9,6.9,0,0,1-1.7-.22,7.1,7.1,0,0,1-1.66-.6l.47-2.13a6.67,6.67,0,0,0,1.36.48,7.07,7.07,0,0,0,1.51.16A2.58,2.58,0,0,0,40,39.31a1.92,1.92,0,0,0,.55-1.52v-1a3.18,3.18,0,0,1-1.1.91,3.26,3.26,0,0,1-1.46.31,3.58,3.58,0,0,1-3-1.43,6,6,0,0,1-1.09-3.77Zm2.85.2A4.34,4.34,0,0,0,37.24,35a1.61,1.61,0,0,0,1.52.79,2.32,2.32,0,0,0,1.1-.24,1.8,1.8,0,0,0,.73-.69V30.32a1.91,1.91,0,0,0-.73-.76,2.17,2.17,0,0,0-1.09-.26,1.6,1.6,0,0,0-1.52.93,5.26,5.26,0,0,0-.48,2.42Z" />
                          </g>
                        </g>
                      </svg>
                    </div>
                    <div class="text-effect-description">{{'do_bong' | translate}}</div>
                  </div>
                  <!-- Tạo viền -->
                  <div class="text-effect-shape-item" (click)="dispatchStyles('Tạo stroke')">
                    <div [ngClass]="config['text_style'] == 'stroke' ? 'active' : ''" 
                      class="image">
                      <svg id="Layer_6" data-name="Layer 6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
                        <defs>
                          <style>
                            .cls-6 {
                              fill: none;
                              stroke: #ffa64d;
                              stroke-miterlimit: 10;
                            }
                          </style>
                        </defs>
                        <title>Phong_cach_va_kieu_co</title>
                        <path class="cls-6"
                          d="M28.71,34.78H24.1l-1,3.06h-3L25,23.63h2.92l4.78,14.21h-3Zm-3.9-2.24H28l-1.57-5h-.06Z" />
                        <path class="cls-6"
                          d="M33.39,32.65a6.84,6.84,0,0,1,1.08-4,3.52,3.52,0,0,1,3.05-1.54,3,3,0,0,1,1.56.4,3.53,3.53,0,0,1,1.16,1.15l.22-1.35h2.45V37.8A3.91,3.91,0,0,1,41.56,41a5.62,5.62,0,0,1-3.75,1.13,7,7,0,0,1-1.7-.22,7.1,7.1,0,0,1-1.66-.6l.47-2.13a6.67,6.67,0,0,0,1.36.48,7.14,7.14,0,0,0,1.51.16,2.58,2.58,0,0,0,1.72-.49,1.92,1.92,0,0,0,.55-1.52v-1a3.18,3.18,0,0,1-1.1.91,3.26,3.26,0,0,1-1.46.31,3.61,3.61,0,0,1-3-1.43,6.07,6.07,0,0,1-1.08-3.77Zm2.85.2A4.34,4.34,0,0,0,36.71,35a1.61,1.61,0,0,0,1.51.79,2.34,2.34,0,0,0,1.11-.24,1.8,1.8,0,0,0,.73-.69V30.32a1.91,1.91,0,0,0-.73-.76,2.17,2.17,0,0,0-1.09-.26,1.6,1.6,0,0,0-1.52.93,5.26,5.26,0,0,0-.48,2.42Z" />
                      </svg>
                    </div>
                    <div class="text-effect-description">{{'tao_vien' | translate}}</div>
                  </div>
                  <!-- Tô màu nền -->
                  <div class="text-effect-shape-item" (click)="dispatchStyles('background')">
                    <div [ngClass]="config['text_style'] == 'background' ? 'active' : ''"
                      class="image">
                      <svg id="Layer_7" data-name="Layer 7" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
                        <defs>
                          <style>
                            .cls-7 {
                              fill: #e5e5e5;
                            }

                            .cls-8 {
                              fill: #ffa64d;
                            }
                          </style>
                        </defs>
                        <title>Phong_cach_va_kieu_co</title>
                        <rect class="cls-7" x="6.53" y="17.06" width="50.94" height="29.88" rx="5" />
                        <path class="cls-8"
                          d="M28.71,34.78H24.1l-1,3.06h-3L25,23.63h2.92l4.78,14.21h-3Zm-3.9-2.24H28l-1.57-5h-.06Z" />
                        <path class="cls-8"
                          d="M33.39,32.65a6.77,6.77,0,0,1,1.09-4,3.49,3.49,0,0,1,3-1.54,3,3,0,0,1,1.56.4,3.53,3.53,0,0,1,1.16,1.15l.22-1.35h2.45V37.8A3.91,3.91,0,0,1,41.56,41a5.62,5.62,0,0,1-3.75,1.13,7,7,0,0,1-1.7-.22,7.1,7.1,0,0,1-1.66-.6l.47-2.13a6.67,6.67,0,0,0,1.36.48,7.14,7.14,0,0,0,1.51.16,2.58,2.58,0,0,0,1.72-.49,1.92,1.92,0,0,0,.55-1.52v-1a3.18,3.18,0,0,1-1.1.91,3.26,3.26,0,0,1-1.46.31,3.58,3.58,0,0,1-3-1.43,6,6,0,0,1-1.09-3.77Zm2.85.2A4.34,4.34,0,0,0,36.71,35a1.61,1.61,0,0,0,1.52.79,2.32,2.32,0,0,0,1.1-.24,1.8,1.8,0,0,0,.73-.69V30.32a1.91,1.91,0,0,0-.73-.76,2.17,2.17,0,0,0-1.09-.26,1.6,1.6,0,0,0-1.52.93,5.26,5.26,0,0,0-.48,2.42Z" />
                      </svg>
                    </div>
                    <div class="text-effect-description">{{'to_mau_nen' | translate}} </div>
                  </div>
                </div>
                <!-- Cấu hình Đổ bóng -->
                <div class="text-effect-config" *ngIf="config['text_style'] == 'shadow'">
                  <span style="font-weight: 500;line-height:3">{{'do_bong' | translate}}</span>
                  <div class="config-name">
                    <p class="m-0" style="line-height: 1.5">{{'truc_x' | translate}}</p>
                    <nz-input-number [nzMin]="-30" [nzMax]="30" [ngStyle]="{marginLeft: '16px',width: '40%'}"
                      [(ngModel)]="config['filter']['offset_x']"
                      (ngModelChange)="handleSetTextShadow()"
                      (nzBlur)="updateClass()">
                    </nz-input-number>
                  </div>
                  <nz-row>
                    <nz-col nzSpan="24">
                      <nz-slider
                        [(ngModel)]="config['filter']['offset_x']"
                        (ngModelChange)="handleSetTextShadow()"
                        (nzOnAfterChange)="updateClass()"
                        [nzMin]="-10" [nzMax]="10" [nzStep]="0.5">
                      </nz-slider>
                    </nz-col>
                  </nz-row>
                  <div class="config-name">
                    <p class="m-0" style="line-height: 1.5">{{'truc_y' | translate}}</p>
                    <nz-input-number [nzMin]="-10" [nzMax]="10" [nzStep]="0.5" [ngStyle]="{marginLeft: '16px',width: '40%'}"
                      [(ngModel)]="config['filter']['offset_y']"
                      (ngModelChange)="handleSetTextShadow()"
                      (nzBlur)="updateClass()">
                    </nz-input-number>
                  </div>
                  <nz-row>
                    <nz-col nzSpan="24">
                      <nz-slider [nzMin]="-10" [nzMax]="10" [nzStep]="0.5"
                        [(ngModel)]="config['filter']['offset_y']"
                        (ngModelChange)="handleSetTextShadow()"
                        (nzOnAfterChange)="updateClass()">
                      </nz-slider>
                    </nz-col>
                  </nz-row>
                  <div class="config-name">
                    <p class="m-0">{{'do_trong_suot' | translate}}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="50" [ngStyle]="{marginLeft: '16px',width: '40%'}"
                      [(ngModel)]="config['filter']['blur_radius']"
                      (ngModelChange)="handleSetTextShadow()"
                      (nzBlur)="updateClass()">
                    </nz-input-number>
                  </div>
                  <nz-row>
                    <nz-col nzSpan="24">
                      <nz-slider [nzMin]="0" [nzMax]="50"
                      [(ngModel)]="config['filter']['blur_radius']"
                      (ngModelChange)="handleSetTextShadow()"
                      (nzOnAfterChange)="updateClass()">
                    </nz-slider>
                    </nz-col>
                  </nz-row>
                  <div class="config-name">
                    <p class="m-0">{{'mau_bong' | translate}}</p>
                    <input class="input-color" style="width:40%;flex:none" type="button"
                      [style.background]="config['filter']['shadow_color']"
                      [cpOKButton]="true" [(colorPicker)]="config['filter']['shadow_color']"
                      (colorPickerClose)="handleSetTextShadow(); updateClass()" />
                  </div>
                </div>
                <!-- Cấu hình Tạo viền -->
                <div class="text-effect-config" *ngIf="config['text_style'] == 'stroke'">
                  <div class="config-name">
                    <p class="m-0">{{'do_day' | translate}}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="10" [nzStep]="0.5" [ngStyle]="{ width: '40%' }"
                      [ngModel]="class['fee__content']['-webkit-text-stroke-width'] | vhnumber"
                      (nzBlur)="updateClass()"
                      (ngModelChange)="class['fee__content']['-webkit-text-stroke-width'] = $event +'px'">
                    </nz-input-number>
                  </div>
                  <nz-row>
                    <nz-col nzSpan="24">
                      <nz-slider [nzMin]="0" [nzMax]="10" [nzStep]="0.5"
                        [ngModel]="class['fee__content']['-webkit-text-stroke-width'] | vhnumber"
                        (nzOnAfterChange)="updateClass()"
                        (ngModelChange)="class['fee__content']['-webkit-text-stroke-width'] = $event +'px'">
                      </nz-slider>
                    </nz-col>
                  </nz-row>
                  <div class="config-name">
                    <p class="m-0">{{'chon_mau' | translate}}</p>
                    <input class="input-color" style="width:40%;flex:none" type="button"
                      [style.background]="class['fee__content']['-webkit-text-stroke-color']"
                      [cpOKButton]="true" [(colorPicker)]="class['fee__content']['-webkit-text-stroke-color']"
                      (colorPickerClose)="updateClass()" />
                  </div>
                </div>
                <!-- Cấu hình Tô màu nền -->
                <div class="text-effect-config" *ngIf="config['text_style'] == 'background'">
                  <span style="font-weight: 500;line-height:3">{{'to_mau_nen' | translate}} </span>
                  <!-- Bo góc -->
                  <!-- <div class="config-name">
                    <p class="m-0">{{'bo_goc' | translate}}</p>
                    <input class="ant-input-number-input ant-input-number input-number" style="width: 40%; border: 1px solid #d9d9d9 !important;" type="text"
                      [ngModel]="class['fee__wrapper']['border-radius'] | vhpercent" #borderRadiusValue
                      (ngModelChange)="class['fee__wrapper']['border-radius'] = $event;"
                      (blur)="class['fee__wrapper']['border-radius'] = borderRadiusValue.value; handleSetBorderRadius()" />
                  </div>
                  <div>
                    <nz-slider [nzMin]="0" [nzMax]="100" [nzStep]="1"
                      [ngModel]="class['fee__wrapper']['border-radius'] | vhnumber"
                      (nzOnAfterChange)="updateClass(); handleSetBorderRadius()"
                      (ngModelChange)="class['fee__wrapper']['border-radius'] = $event+'%'">
                    </nz-slider>
                  </div> -->
                  <!-- Góc trên bên trái -->
                  <div class="config-name" style="gap:5px">
                    <p class="m-0" style="line-height: 1.5;">{{'goc_tren_ben_trai' | translate}}</p>
                    <input class="ant-input-number-input ant-input-number input-number" style="width: 40%; border: 1px solid #d9d9d9 !important;" type="text"
                      [ngModel]="class['fee__wrapper']['border-top-left-radius'] | vhpercent" #borderRadiusTLValue
                      (ngModelChange)="class['fee__wrapper']['border-top-left-radius'] = $event;"
                      (blur)="class['fee__wrapper']['border-top-left-radius'] = borderRadiusTLValue.value; updateClass()" />
                  </div>
                  <div>
                    <nz-slider [nzMin]="0" [nzMax]="100" [nzStep]="1"
                      [ngModel]="class['fee__wrapper']['border-top-left-radius'] | vhnumber"
                      (nzOnAfterChange)="updateClass()"
                      (ngModelChange)="class['fee__wrapper']['border-top-left-radius'] = $event+'%';">
                    </nz-slider>
                  </div>
                  <!-- Góc trên bên phải -->
                  <div class="config-name">
                    <p class="m-0" style="line-height: 1.5;">{{'goc_tren_ben_phai' | translate}}</p>
                    <input class="ant-input-number-input ant-input-number input-number" style="width: 40%; border: 1px solid #d9d9d9 !important;" type="text"
                      [ngModel]="class['fee__wrapper']['border-top-right-radius'] | vhpercent" #borderRadiusTRValue
                      (ngModelChange)="class['fee__wrapper']['border-top-right-radius'] = $event;"
                      (blur)="class['fee__wrapper']['border-top-right-radius'] = borderRadiusTRValue.value; updateClass()" />
                  </div>
                  <div>
                    <nz-slider [nzMin]="0" [nzMax]="100" [nzStep]="1"
                      [ngModel]="class['fee__wrapper']['border-top-right-radius'] | vhnumber"
                      (nzOnAfterChange)="updateClass()"
                      (ngModelChange)="class['fee__wrapper']['border-top-right-radius'] = $event+'%';">
                    </nz-slider>
                  </div>
                  <!-- Góc dưới bên trái -->
                  <div class="config-name">
                    <p class="m-0" style="line-height: 1.5;">{{'goc_duoi_ben_trai' | translate}}</p>
                    <input class="ant-input-number-input ant-input-number input-number" style="width: 40%; border: 1px solid #d9d9d9 !important;" type="text"
                      [ngModel]="class['fee__wrapper']['border-bottom-left-radius'] | vhpercent" #borderRadiusBLValue
                      (ngModelChange)="class['fee__wrapper']['border-bottom-left-radius'] = $event;"
                      (blur)="class['fee__wrapper']['border-bottom-left-radius'] = borderRadiusBLValue.value; updateClass()" />
                  </div>
                  <div>
                    <nz-slider [nzMin]="0" [nzMax]="100" [nzStep]="1"
                      [ngModel]="class['fee__wrapper']['border-bottom-left-radius'] | vhnumber"
                      (nzOnAfterChange)="updateClass()"
                      (ngModelChange)="class['fee__wrapper']['border-bottom-left-radius'] = $event+'%';">
                    </nz-slider>
                  </div>
                  <!-- Góc dưới bên phải -->
                  <div class="config-name">
                    <p class="m-0" style="line-height: 1.5;">{{'goc_duoi_ben_phai' | translate}}</p>
                      <input class="ant-input-number-input ant-input-number input-number" style="width: 40%; border: 1px solid #d9d9d9 !important;" type="text"
                        [ngModel]="class['fee__wrapper']['border-bottom-right-radius'] | vhpercent" #borderRadiusBRValue
                        (ngModelChange)="class['fee__wrapper']['border-bottom-right-radius'] = $event;"
                        (blur)="class['fee__wrapper']['border-bottom-right-radius'] = borderRadiusBRValue.value; updateClass()" />
                  </div>
                  <div>
                    <nz-slider [nzMin]="0" [nzMax]="100" [nzStep]="1"
                      [ngModel]="class['fee__wrapper']['border-bottom-right-radius'] | vhnumber"
                      (nzOnAfterChange)="updateClass()"
                      (ngModelChange)="class['fee__wrapper']['border-bottom-right-radius'] = $event+'%';">
                    </nz-slider>
                  </div>
                  <!-- Chọn màu -->
                  <div class="config-name">
                    <p class="m-0">{{'chon_mau' | translate}}</p>
                    <input class="input-color" style="width:40%;flex:none" type="button"
                      [style.background]="class['fee__wrapper']['background-color']"
                      [cpOKButton]="true" [(colorPicker)]="class['fee__wrapper']['background-color']"
                      (colorPickerClose)="updateClass()" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </li>
      <!-- Cấu hình khoảng đệm-->
      <li nz-submenu nzTitle="{{'khoang_dem' | translate}}" [(nzOpen)]="openMap.menu11"
        (nzOpenChange)="openHandler('menu11')">
        <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
          [classPadding]="class['fee__content']" [paddingConfigs]="[
          { type: 'top' },
          { type: 'bottom' },
          { type: 'left' },
          { type: 'right' },
        ]">
        </app-padding-config>
      </li>
      <!-- Cấu hình viền-->
      <li nz-submenu nzTitle="{{'vien' | translate}}" [(nzOpen)]="openMap.menu12"
        (nzOpenChange)="openHandler('menu12')">
        <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
          [borderClass]="class['fee__content']" [id_object]="objectChoosing._id">
        </app-borders-config>

        <!-- Nút mở rộng -->
        <div class="item-border my-3" style="float: right">
          <p class="m-0 title-border my-2" (click)="openViewAll(styles_field[1])">
            {{'bo_goc' | translate}} &#8594;
          </p>
        </div>
      </li>
      <!-- HIỆU ỨNG -->
      <li nz-submenu nzTitle="{{'hieu_ung' | translate}}" [(nzOpen)]="openMap.menu4"
        (nzOpenChange)="openHandler('menu4')">
        <app-choose-animations-config
          [elementChoosing]="objectChoosing"
          [id_object]="objectChoosing._id"
          [device]="device"
          [class]="class"
          [config]="config"
          [staticdata]="staticdata"
          [cursorClass]="class['fee']"
          [effect_hover]="effect_hover"
          [customize]="customize"
          (openAnimationDetail)="openAnimationDetail($event)"
          [effectFileUsing]="'text'">
        </app-choose-animations-config>
      </li>
    </ul>
  </ng-container>

  <!-- CẤU HÌNH CHI TIẾT -->
  <div class="view-more" *ngIf="isViewAll">
    <!-- Cấu hình chi tiết hiệu ứng -->
    <div class="editor_effect-hover" *ngIf="config['animation-selected'].id != '000000' && currentViewAll.index == 1">
      <app-animations-config [type]="type" [elementChoosing]="objectChoosing" [device]="device"
        [staticdata]="staticdata" [id_object]="objectChoosing._id" [customize]="customize"></app-animations-config>
    </div>
    <!-- Cấu hình chi tiết viền -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 2">
      <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
        [borderRadiusClass]="class['fee__content']" [id_object]="objectChoosing._id">
      </app-borders-radius-config>
    </div>
  </div>
</div>